import {useEffect} from 'react'
import { landing } from '../database/ExportAssets'
import { useNavigate,useSearchParams } from 'react-router-dom'

const LandingPage = () => {
  const navigate=useNavigate();
  const [searchParams]=useSearchParams();
  
  const uid=searchParams.get("uid");
  const campId=searchParams?.get("camp");
  const rcid=searchParams?.get("rcid");
  console.log("params is:::",uid,campId,rcid);
  useEffect(()=>
  {
    if(uid && uid!==null && uid!=="undefined")
      {
      localStorage.setItem("uid",uid)
      }
    if(campId )
      {
        localStorage.setItem("campId",campId);
        sessionStorage.setItem("campId",campId);
      }
    if(rcid)
    {
       sessionStorage.setItem("rcid",rcid);
       localStorage.setItem("rcid",rcid);
    }
  },[])
  useEffect(()=>
  {
    const timeout=setTimeout(()=>{
     navigate("/home")
  },2000)
   return ()=>clearTimeout(timeout)
},[]);
    
  return (
    <div className='h-screen'>
      <img src={landing} alt="landing" className='w-full h-screen object-fill'/>
    </div>
  )
}


export default LandingPage